export default {
  getLocationsId(locations) {
    const locationsArray = locations.split('|');
    return locationsArray.map(location => {
      const loc = location.split('+');
      return loc[1];
    });
  }
};
